import { scrollToSection } from "./Header";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-black text-mist/70 border-t border-mist/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
      <div className="flex items-center">
        <img
          src="/assets/logo-hi-dark.webp"
          alt="Kritajna Ventures LLP — कृतज्ञा"
          className="h-24 sm:h-32 w-auto object-contain"
        />
      </div>

      <nav className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm" data-testid="footer-nav">
        <a href="#about" data-testid="footer-about-link" onClick={(e) => { e.preventDefault(); scrollToSection("#about"); }} className="hover:text-mist transition-colors duration-300">About Us</a>
        <a href="#verticals" data-testid="footer-verticals-link" onClick={(e) => { e.preventDefault(); scrollToSection("#verticals"); }} className="hover:text-mist transition-colors duration-300">Core Verticals</a>
        <a href="#contact" data-testid="footer-contact-link" onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); }} className="hover:text-mist transition-colors duration-300">Contact Us</a>
        <a href="mailto:admin@kritajnaventures.com" data-testid="footer-email-link" className="hover:text-mist transition-colors duration-300">admin@kritajnaventures.com</a>
      </nav>
    </div>
    <div className="border-t border-mist/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-mist/40">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Kritajna Ventures LLP. All rights reserved.</p>
        <p>Kerala, India · Grounded in Value. Built for Scale.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
